import _ from 'lodash';

export const findCurrentCompanyMember = (companyMembers, currentCompanyId) => _.find(
  companyMembers, (companyMember) => companyMember.company.id === currentCompanyId,
);
